import { render, staticRenderFns } from "./Fragment.vue?vue&type=template&id=3c44e316&"
import script from "./Fragment.vue?vue&type=script&lang=ts&"
export * from "./Fragment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports